var _defs, _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagDotFilledGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_filled",
    d: "M32.249 17.789c-.045.014-5.998.338-11.729-3.754-5.458-3.897-9.733-1.142-9.733-1.142V24.55s3.918-4.278 11.255-2.409 10.208-4.353 10.207-4.353zM10.816 7.983V37.74M7.4 37.74h6.833"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 10.816,
    cy: 7.07,
    r: 2.29
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 10.816,
    cy: 7.07,
    r: 2.29
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagDotFilledGray);
export default __webpack_public_path__ + "static/media/flagDotFilledGray.013ad079043018e34bc920a6681f5be4.svg";
export { ForwardRef as ReactComponent };